import React, { useEffect, useRef } from "react";
import { SessionState } from "sip.js";
import { useSessionCall, SessionDirection } from "../../helper/sipProvider";
import { Typography, Paper } from "@mui/material";

import ringtone from "../phone/ringtone.mp3";
import { ImPhone, ImPhoneHangUp } from "react-icons/im";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { CallTimer } from "../phone/CallTimer";
import { useDispatch, useSelector } from "react-redux";
import { updateCallBalance, updatedMoney } from "../../slices/WalletSlice";
import { buildVoiceOnlySessionOptions } from "../../helper/webrtcAudio";
import { pickSipDisplayValue } from "../../helper/sipDisplay";

const INCOMING_ALERT_STATES = [
  SessionState.Initial,
  SessionState.Establishing,
];

const IncomingCallModal = (props) => {
  const { sessionId } = props;
  const {
    isMuted,
    decline,
    hangup,
    mute,
    answer,
    session,
    unmute,
    direction,
    timer,
  } = useSessionCall(sessionId);

  const audioRef = useRef(null);
  const sip = useSelector((state) => state.wallet.extension_number);
  const dispatch = useDispatch();
  const userBalance = useSelector((state) => state.wallet.balance);
  const isIncomingCall = direction === SessionDirection.INCOMING;
  const isIncomingRinging =
    Boolean(session) &&
    isIncomingCall &&
    INCOMING_ALERT_STATES.includes(session.state);
  const isSessionActive =
    Boolean(session) && session.state !== SessionState.Terminated;
  const shouldRenderModal =
    isSessionActive &&
    (isIncomingRinging ||
      direction === SessionDirection.OUTGOING ||
      session.state === SessionState.Established);

  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(ringtone);
      audioRef.current.loop = true;
    }

    const audio = audioRef.current;

    if (isIncomingRinging) {
      audio.play().catch((error) => console.error("Error playing audio:", error));
    } else {
      audio.pause();
      audio.currentTime = 0;
    }

    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [isIncomingRinging]);

  useEffect(() => {
    const defaultTitle = "VoIPFlow";

    if (isIncomingRinging) {
      document.title = `Incoming Call - ${sip || "Extension"}`;
      return () => {
        document.title = defaultTitle;
      };
    }

    document.title = defaultTitle;

    return undefined;
  }, [isIncomingRinging, sip]);


// <----- OUTGOING call pr wallet se amount subtruct krne ke liye functionalities add  ki he ------>

  useEffect(() => {
    let intervalId;

    const handleCallEstablish = () => {
      if (session && session.state === SessionState.Established && direction === SessionDirection.OUTGOING) {
        intervalId = setInterval(async () => {
          const cost = 1; // $1 per 30 seconds
          if (userBalance >= cost) {
            const newBalance = await dispatch(updateCallBalance({ amount: cost })).unwrap();
            await dispatch(updatedMoney(newBalance));
          } else {
            hangup();
          }
        }, 30000); // 30 seconds interval
      }
    };

    if (session && session.state === SessionState.Established) {
      // handleCallEstablish();
    }

    return () => clearInterval(intervalId);
  }, [session, dispatch, userBalance, hangup]);



  const getDisplayNumber = () => {
    if (!session) {
      return "Unknown";
    }

    if (direction === SessionDirection.OUTGOING) {
      return (
        pickSipDisplayValue(
          session.request.to?.uri?.user,
          session.remoteIdentity?.uri?.user,
          session.request.to?.displayName
        ) || "Unknown"
      );
    }

    return (
      pickSipDisplayValue(
        session.request.from?.uri?.user,
        session.remoteIdentity?.uri?.user,
        session.request.from?.displayName,
        session.remoteIdentity?.displayName
      ) || "Unknown"
    );
  };
  return shouldRenderModal ? (
    <div className={`call-modal ${isIncomingRinging ? "call-modal--incoming" : ""}`}>
      <Paper elevation={3} className="call-modal-content">
        <div className="call-modal-left">
          <div
            className="call-modal-avatar"
            style={{ backgroundImage: 'url("assets/img/messages-3.jpg")' }}
          ></div>
          <div className="call-modal-info" style={{padding:"0%",margin:"-5px"}}>
            <Typography variant="subtitle1">
              Session ID: {session.id.length > 4 ? session.id.substring(0, 10) : session.id}
              ......
            </Typography>
            <Typography variant="subtitle1" style={{display:"flex"}}>
              Number: {getDisplayNumber()}
            </Typography>
            <Typography variant="caption" className="call-modal-extension">
              Extension: {sip || "Unknown"}
            </Typography>
            <div className="call-modal-actions">
              {session.state && (
                <Typography variant="body2">{session.state}</Typography>
              )}
              {isIncomingRinging && (
                  <div className="call-modal-actions">
                    <ImPhone
                      className="call-modal-action-icon call-modal-action-icon--answer"
                      onClick={() => answer(buildVoiceOnlySessionOptions())}
                    />
                    <ImPhoneHangUp
                      className="call-modal-action-icon call-modal-action-icon--hangup"
                      onClick={decline}
                    />
                  </div>
                )}
              {(session.state === SessionState.Initial ||
                session.state === SessionState.Establishing) &&
                direction === SessionDirection.OUTGOING && (
                  <ImPhoneHangUp
                    className="call-modal-action-icon call-modal-action-icon--hangup"
                    onClick={hangup}
                  />
                )}
              {session.state === SessionState.Established && (
                <>
                  <ImPhoneHangUp
                    className="call-modal-action-icon call-modal-action-icon--hangup"
                    onClick={hangup}
                  />
                  <div onClick={isMuted ? unmute : mute}>
                    {isMuted ? (
                      <FaMicrophoneSlash
                        className="call-modal-action-icon call-modal-action-icon--muted"
                      />
                    ) : (
                      <FaMicrophone
                        className="call-modal-action-icon call-modal-action-icon--muted"
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="call-modal-right">
          <Typography variant="body2" className="call-modal-duration">
            Duration:{" "}
            {timer?.answeredAt && (
              <CallTimer
                isEnd={session.state === "Terminated"}
                startAt={timer.answeredAt}
              />
            )}
            {!timer?.answeredAt && <span>N/C</span>}
          </Typography>
          <div className="call-modal-status">
            <div className="call-modal-status-indicator">
              <div className="call-modal-status-indicator-inner"></div>
            </div>
            <Typography variant="caption">
              {isIncomingRinging
                ? "Incoming call ringing"
                : direction === SessionDirection.INCOMING
                  ? "Incoming call"
                  : "Outgoing Call"}
            </Typography>
          </div>
        </div>
      </Paper>
    </div>
  ) : null;
};

export default IncomingCallModal;
